var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout",attrs:{"role":"main"}},[_c('b-container',[_c('b-row',{staticClass:"login-wrapper"},[(!_vm.$msal.isAuthenticated())?_c('button',{staticClass:"loginButton",on:{"click":function($event){return _vm.$msal.signIn()}}},[_vm._v("Sign In")]):_vm._e()])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }